export default "__VITE_ASSET__D8BzMa6x__"